import React, { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import axios from 'axios';
import { useLanguage } from '../i18n/LanguageContext';

function VerifyEmail() {
  const { isEnglish } = useLanguage();
  const [searchParams] = useSearchParams();
  const [message, setMessage] = useState('');
  const [status, setStatus] = useState('waiting'); // 'waiting', 'loading', 'success', 'error'
  const token = searchParams.get('token');

  const handleConfirm = () => {
    if (!token) {
      setStatus('error');
      setMessage(isEnglish ? 'The verification token is missing from the URL.' : 'Token manquant dans l URL.');
      return;
    }

    setStatus('loading');
    setMessage(isEnglish ? 'Verifying your email address...' : 'Verification en cours...');

    axios
      .get(`https://1irywxa5c3.execute-api.ca-central-1.amazonaws.com/prod/verify-email?token=${token}`, {
        headers: { 'User-Agent': 'ManualUserConfirm' } // pour éviter les faux positifs backend
      })
      .then(() => {
        setMessage(isEnglish ? 'Your email address has been verified. Redirecting in a few seconds...' : 'Votre adresse email a ete verifiee avec succes. Redirection dans quelques secondes...');
        setStatus('success');
        setTimeout(() => {
          window.location.href = '/';
        }, 5000);
      })
      .catch(() => {
        setMessage(isEnglish ? 'This verification link is invalid, expired, or has already been used.' : 'Le lien est invalide, expire ou deja utilise.');
        setStatus('error');
      });
  };

  return (
    <div className="container text-center mt-5">
      <h2 className="mb-4">{isEnglish ? 'Verify your email address' : 'Verification de votre adresse email'}</h2>

      {status === 'waiting' && (
        <>
          <p className="fs-5">{isEnglish ? 'Click the button below to confirm your email address.' : 'Cliquez sur le bouton ci dessous pour confirmer votre adresse email :'}</p>
          <button className="btn btn-primary" onClick={handleConfirm}>
            {isEnglish ? 'Confirm my email address' : 'Confirmer mon adresse email'}
          </button>
        </>
      )}

      {status === 'loading' && (
        <div className="d-flex justify-content-center my-4">
          <div className="spinner-border text-primary" role="status" aria-hidden="true" />
          <span className="ms-3" role="status">{isEnglish ? 'Verifying...' : 'Verification en cours...'}</span>
        </div>
      )}

      {status !== 'waiting' && status !== 'loading' && (
        <div className={`alert ${status === 'success' ? 'alert-success' : 'alert-danger'} fs-5 mt-4`}>
          {message}
        </div>
      )}

      {status === 'success' && (
        <p className="text-muted">{isEnglish ? 'You will be redirected automatically in a few seconds.' : 'Vous allez etre redirige automatiquement dans quelques secondes...'}</p>
      )}

      <button className="btn btn-outline-primary mt-4" onClick={() => window.location.href = '/'}>
        {isEnglish ? 'Back to home' : 'Retour a l accueil'}
      </button>
    </div>
  );
}

export default VerifyEmail;
